export const IMPERSONATION_FRAGMENT_KEY = 'impersonation_token'

const JWT_PATTERN = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/
const MAX_TOKEN_LENGTH = 8192
let pendingHandoff = null

export const isValidImpersonationTokenShape = (value) => {
  const token = String(value || '').trim()
  return Boolean(token && token.length <= MAX_TOKEN_LENGTH && JWT_PATTERN.test(token))
}

export const buildLoginAsUrl = (token) => {
  if (!isValidImpersonationTokenShape(token)) {
    throw new Error('A valid impersonation JWT is required')
  }

  return `/login-as#${IMPERSONATION_FRAGMENT_KEY}=${encodeURIComponent(token)}`
}

export const consumeImpersonationToken = ({
  location = window.location,
  history = window.history,
} = {}) => {
  const searchParams = new URLSearchParams(location.search || '')
  const legacyQueryRejected =
    searchParams.has('token') || searchParams.has(IMPERSONATION_FRAGMENT_KEY)
  const fragmentParams = new URLSearchParams(String(location.hash || '').replace(/^#/, ''))
  const candidate = legacyQueryRejected ? '' : fragmentParams.get(IMPERSONATION_FRAGMENT_KEY)
  const token = isValidImpersonationTokenShape(candidate) ? candidate.trim() : null
  const reason = legacyQueryRejected
    ? 'query_transport_rejected'
    : token
    ? null
    : 'invalid_fragment'

  if (location.hash || legacyQueryRejected) {
    history.replaceState(history.state, '', location.pathname || '/login-as')
  }

  return {token, reason}
}

export const acquireImpersonationHandoff = (dependencies) => {
  const location = dependencies?.location || window.location
  const consumed = consumeImpersonationToken(dependencies)
  const pathname = location.pathname || '/login-as'

  if (consumed.token || consumed.reason === 'query_transport_rejected') {
    pendingHandoff = {pathname, value: consumed}
    return consumed
  }

  if (pendingHandoff?.pathname === pathname) {
    return pendingHandoff.value
  }

  return consumed
}

export const releaseImpersonationHandoff = (handoff) => {
  if (pendingHandoff?.value === handoff) {
    pendingHandoff = null
  }
}
